import React from 'react'

const ServiceCarouselItem = (image, index) => {
    return (
        <img src = {image.image} className = 'Service-Page-Carousel-Container-Image'/>
    )
}

export default ServiceCarouselItem